import React from 'react';
import './GoogleReviewCTA.css';
import { FaGoogle, FaStar, FaExternalLinkAlt } from 'react-icons/fa';
import { GOOGLE_REVIEW_URL } from '../../constants/reviewConstants';

/**
 * GoogleReviewCTA Component
 * 
 * Reusable Google Review Call-To-Action component designed to encourage
 * customers to leave authentic reviews on Google Maps for Bappa Taxi Services.
 * 
 * @param {Object} props
 * @param {string} [props.variant='section'] - 'section' | 'card' | 'compact' | 'inline'
 * @param {string} [props.title] - Custom title text
 * @param {string} [props.subtitle] - Custom subtitle/description text
 * @param {string} [props.buttonText] - Custom button text (defaults to "⭐ Write a Google Review")
 * @param {boolean} [props.showStars=true] - Whether to show the 5-star visual
 * @param {boolean} [props.showGoogleBadge=true] - Whether to show the Google badge
 * @param {string} [props.className=''] - Additional custom CSS classes
 */
const GoogleReviewCTA = ({
  variant = 'section',
  title = 'Bappa Taxi Services would love your feedback',
  subtitle = 'Had a great experience with us? Share your experience and help other travelers discover Bappa Taxi Services.',
  buttonText = '⭐ Write a Google Review',
  showStars = true,
  showGoogleBadge = true,
  className = ''
}) => {
  return (
    <div className={`google-review-cta google-review-cta--${variant} ${className}`}>
      <div className="google-review-cta-container">
        {showGoogleBadge && (
          <div className="google-review-badge">
            <span className="google-icon-wrapper" aria-hidden="true">
              <FaGoogle className="google-icon" />
            </span>
            <span className="google-badge-text">Google Reviews</span>
          </div>
        )}

        {showStars && (
          <div className="google-review-stars" aria-label="5 out of 5 stars rating on Google">
            {[...Array(5)].map((_, i) => (
              <FaStar key={i} className="review-star-icon" aria-hidden="true" />
            ))}
            <span className="review-rating-label">5.0 Star Rated on Google</span>
          </div>
        )}

        <div className="google-review-content">
          <h3 className="google-review-title">{title}</h3>
          <p className="google-review-subtitle">{subtitle}</p>
        </div>

        <div className="google-review-action">
          <a
            href={GOOGLE_REVIEW_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="google-review-btn"
            aria-label="Write a Google review for Bappa Taxi Services (opens in a new tab)"
          >
            <span className="google-review-btn-text">{buttonText}</span>
            <FaExternalLinkAlt className="google-review-btn-icon" aria-hidden="true" />
          </a>
        </div>
      </div>
    </div>
  );
};

export default GoogleReviewCTA;
